// Alma ERP — سجل النظام (آخر 300 حركة) — للأدمن
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { users as usersApi } from "../services/api";

const th = { padding: "8px 12px", textAlign: "right", fontSize: 11.5, color: "#475569", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
const td = { padding: "6px 12px", borderTop: "1px solid #f1f5f9" };

export default function AuditPage() {
  const [rows, setRows] = useState([]); const [q, setQ] = useState(""); const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); usersApi.audit().then((r) => setRows(r.data.rows || [])).catch((e) => toast.error(e.response?.data?.error || "تعذّر التحميل")).finally(() => setLoading(false)); };
  useEffect(load, []);
  const needle = q.trim().toLowerCase();
  const list = needle ? rows.filter((a) => [a.user_display_name, a.user_email, a.module, a.action, a.entity_label, a.entity_id].some((v) => String(v || "").toLowerCase().includes(needle))) : rows;
  return (
    <div className="page">
      <div className="page-head"><div><h1>🧾 سجل النظام</h1><p>آخر 300 حركة على النظام: الدخول، التعديلات، إدارة المستخدمين، رسائل الموقع.</p></div>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="بحث في السجل" style={{ marginInlineStart: "auto", padding: "7px 10px", border: "1px solid #cbd5e1", borderRadius: 8, fontFamily: "inherit", fontSize: 13, width: 240 }} />
        <button type="button" onClick={load} style={{ padding: "7px 13px", background: "#fff", color: "#0f766e", border: "1px solid #99f6e4", borderRadius: 9, fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>↻ تحديث</button>
      </div>
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "auto", maxHeight: "calc(100vh - 140px)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead><tr style={{ background: "#f8fafc", position: "sticky", top: 0 }}>{["الوقت", "المستخدم", "القسم", "الحركة", "العنصر"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>
            {list.map((a) => <tr key={a.id}><td style={{ ...td, whiteSpace: "nowrap", color: "#64748b" }}>{new Date(a.created_at).toLocaleString("en-GB")}</td><td style={td}>{a.user_display_name || a.user_email}</td><td style={td}>{a.module}</td><td style={td}>{a.action}</td><td style={td}>{a.entity_label || a.entity_id || ""}</td></tr>)}
            {!loading && !list.length && <tr><td colSpan={5} style={{ padding: 20, textAlign: "center", color: "#94a3b8" }}>لا حركات</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
